import React from 'react'

import { useForm } from '../../../../../packages/kiti/components/form/form/FormHandler'
import DayOfMonthSentence from './DayOfMonthSentence'
import DayOfWeekSentence from './DayOfWeekSentence'
import TimeSentence from './TimeSentence'

const FrequencySentence = () => {
  const form = useForm()

  if (!form.event?.startsWith('every_')) return false

  return (
    <>
      <DayOfMonthSentence />
      <DayOfWeekSentence />
      <TimeSentence />
    </>
  )
}

export default FrequencySentence
